<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        12/05/2023
      </mat-panel-title>
      <mat-panel-description>
        <p><b>Symptoms :</b> Pain with urination associated with burning sensation and increased frequency of urination.</p>
        <p><b>Condition:</b> Pain started one day ago female with history of hypertension,dibetes type 2. Frequent UTI
          presents new pain. </p>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <p><b>Clinical Status :</b> Relapse </p>
    <p><b>Verification:</b> Confirmed</p>
    <p><b>Severity: </b>Confirmed</p>
    <p><b>Body Site: </b>Confirmed</p>
    <p><b>Notes: </b>Patient has tried increasing water intake with no relief, she states. This similar to prior UTI
      symptoms.</p>
  </mat-expansion-panel>
</mat-accordion>